/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadAIImageRequest
 */
export interface UploadAIImageRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadAIImageRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof UploadAIImageRequest
     */
    category: string;
}

export function UploadAIImageRequestFromJSON(json: any): UploadAIImageRequest {
    return UploadAIImageRequestFromJSONTyped(json, false);
}

export function UploadAIImageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadAIImageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['content'],
        'category': json['category'],
    };
}

export function UploadAIImageRequestToJSON(value?: UploadAIImageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'category': value.category,
    };
}


